import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'
import {
  originalAuthorAvatarUrlResolver,
  originalAuthorHandleResolver,
  originalAuthorNameResolver,
  originalAuthorResolver,
  originalAuthorUrlResolver,
  originalAuthorVerifiedResolver
} from './originalAuthor'

const streamDataFieldResolvers: FieldResolver[] = [
  originalAuthorAvatarUrlResolver,
  originalAuthorHandleResolver,
  originalAuthorNameResolver,
  originalAuthorResolver,
  originalAuthorUrlResolver,
  originalAuthorVerifiedResolver
]

const originalAuthorRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = {} as StreamData
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  return result
}

export default originalAuthorRelatedFieldsResolver
